export default __webpack_public_path__ + "static/1-ad5f162a418413cd6f2b43007ebe5106.jpeg";